import { createSlice, nanoid, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import BaseUrl from "../../../assets/utils/accessToken";
const initialState = {
  ResearchAndDevelopmentActivities: [],
  ResearchAndDevelopmentActivitiesStatus: "idle",
  ResearchAndDevelopmentActivityStatus: "idle",
  error: null,
  ResearchAndDevelopmentActivity: null,
  ResearchAndDevelopmentActivitiesByProgram: [],
  ResearchAndDevelopmentActivitiesByProgramStatus: "idle"
};

export const fetchResearchAndDevelopmentActivitiesByPersonId = createAsyncThunk(
  "ResearchAndDevelopmentActivity/fetchResearchAndDevelopmentActivitiesByPersonId",
  async (person_id) => {
    const token = localStorage.getItem("token");
    const response = await axios.get(
      BaseUrl + `/r_dActivities/byStaff/?staff_id=${person_id}`,
      {
        headers: {
          Authorization: `Token ${token}`,
        },
      }
    );
    console.log(response.data, "response.data of groups");

    return response.data;
  }
);
export const fetchResearchAndDevelopmentActivitiesByProgramId = createAsyncThunk(
  "ResearchAndDevelopmentActivity/fetchResearchAndDevelopmentActivitiesByProgramId",
  async (program_id) => {
    const token = localStorage.getItem("token");
    const response = await axios.get(
      BaseUrl + `/professionalDevelopmentFaculty/by_program/?program_id=${program_id}`,
      {
        headers: {
          Authorization: `Token ${token}`,
        },
      }
    );
    console.log(response.data, "response.data of groups");

    return response.data;
  }
);
export const addNewResearchAndDevelopmentActivity = createAsyncThunk(
  "ResearchAndDevelopmentActivity/addNewResearchAndDevelopmentActivity",
  async (body, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.post(BaseUrl + "/r_dActivities/create/", body, {
        headers: {
          Authorization: `Token ${token}`,
        },
      });
      console.log(response.data, "response.data of groups");

      return response.data;
    } catch (err) {
      let error = err; // cast the error for access
      if (!error.response) {
        throw err;
      }
      // We got validation errors, let's return those so we can reference in our component and set form errors
      console.log("error.response from inside the CAT", error.response);
      return rejectWithValue(error.response);
    }
  }
);
export const UpdateResearchAndDevelopmentActivity = createAsyncThunk(
  "ResearchAndDevelopmentActivity/UpdateResearchAndDevelopmentActivity",
  async (data, thunkAPI) => {
    const token = localStorage.getItem("token");
    try {
      const response = await axios.put(
        BaseUrl + `/r_dActivities/${data.id}/edit/`,
        data.modified,
        {
          headers: {
            Authorization: `token ${token}`,
          },
        }
      );
      console.log(data, "education");
      console.log(response.data, "response.data");
      return response.data;
    } catch (error) {
      console.error("Failed to update the education: ", error);
    }
  }
);

export const deleteResearchAndDevelopmentActivity = createAsyncThunk(
  "ResearchAndDevelopmentActivity/deleteResearchAndDevelopmentActivity",
  async (id) => {
    const token = localStorage.getItem("token");
    const response = await axios.delete(BaseUrl + `/r_dActivities/${id}/delete/`, {
      headers: {
        Authorization: `token ${token}`,
      },
    });

    return response.data;
  }
);

const ResearchAndDevelopmentActivitySlice = createSlice({
  name: "ResearchAndDevelopmentActivity",
  initialState,
  extraReducers: {
    [fetchResearchAndDevelopmentActivitiesByPersonId.pending]: (state, action) => {
      state.ResearchAndDevelopmentActivitiesStatus = "loading";
    },
    [fetchResearchAndDevelopmentActivitiesByPersonId.fulfilled]: (state, action) => {
      state.ResearchAndDevelopmentActivitiesByProgram = "succeeded";
      // Add any fetched posts to the array
      state.ResearchAndDevelopmentActivities = action.payload;
    },
    [fetchResearchAndDevelopmentActivitiesByPersonId.rejected]: (state, action) => {
      state.ResearchAndDevelopmentActivitiesStatus = "failed";
      state.error = action.payload;
    },
    [fetchResearchAndDevelopmentActivitiesByProgramId.pending]: (state, action) => {
      state.ResearchAndDevelopmentActivitiesByProgramStatus = "loading";
    },
    [fetchResearchAndDevelopmentActivitiesByProgramId.fulfilled]: (state, action) => {
      state.ResearchAndDevelopmentActivitiesByProgramStatus = "succeeded";
      // Add any fetched posts to the array
      state.ResearchAndDevelopmentActivitiesByProgram = action.payload;
    },
    [fetchResearchAndDevelopmentActivitiesByProgramId.rejected]: (state, action) => {
      state.ResearchAndDevelopmentActivitiesByProgramStatus = "failed";
      state.error = action.payload;
    },
    
    [addNewResearchAndDevelopmentActivity.fulfilled]: (state, action) => {
      // state.groups.push(action.payload);
    },

    [UpdateResearchAndDevelopmentActivity.fulfilled]: (state, action) => {
      // state.groups.push(action.payload);
    },
    [deleteResearchAndDevelopmentActivity.fulfilled]: (state, action) => {},
  },
});

export default ResearchAndDevelopmentActivitySlice.reducer;
// export const  groups = state => state.group.groups
